import { createContext, useContext } from "react";

export const LenisContext = createContext(null);
export const useLenis = () => useContext(LenisContext);

export const scrollToId = (lenis, id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
